/**
 * Enumération des modes possibles pour l'affichage de la vue des trajets dans l'écran "Gestion Navette".
 */
export enum ModeGestionNavette {
	CREATION_MODIFICATION = 'CREATION_MODIFICATION',
	SELECTION = 'SELECTION',
}